import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';

const PieChart = ({ getLabels, getSeries, name }) => {
  const [labels, setLabels] = useState([]);
  const [series, setSeries] = useState([]);

  useEffect(() => {
    setLabels(getLabels);
    setSeries(getSeries);
  }, [getLabels, getSeries]);

  const options = {
    chart: {
      type: 'donut'
    },
    labels: labels,
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        legend: {
          position: 'bottom'
        }
      }
    }]
  };

  return (
    <div id="chart">
      <div className='text-xl mb-2'>{name}</div>
      <Chart
        options={options}
        series={series}
        type="donut"
        // height="350"
      />
    </div>
  );
};

export default PieChart;
